import { Component, OnInit } from '@angular/core';
import { APIService } from '../../../../app/api.service';
import { CommonService } from '../../../services/common.service';
import { formatDate, DatePipe } from '@angular/common';


@Component({
    selector: 'app-voucher-print',
    templateUrl: './voucher-print.component.html',
    styleUrls: ['./voucher-print.component.scss']
})
export class VoucherPrintComponent implements OnInit {
    constructor(private apiService: APIService, private commonService: CommonService) { }
    jarvisData: any = [];
    agencyData: any = [];
    userData: any = [];
    voucherID: number = 0;
    ledgers: any = [];
    ledger: any = [];
    editDataList: any = [];
    dataTbl: any = [];
    AgencyName: string = ''
    City: string = '';
    State: string = '';
    ledgerName: any = ''
    CreditTotal: number = 0;
    DebitTotal: number = 0;
    vuchrID: any = 0;
    vuchrHistoryID: any = 0;
    pipe = new DatePipe('en-US');
    now = Date.now();

    data: any = {
        voucherType: '',
        voucherTypeID: '0',
        voucherNO: '',
        voucherDate: this.pipe.transform(this.now, 'dd-MMM-yy'),
        ledgerID: '',
        ledgerName: '',
        credit: '0',
        debit: '0',
        curBal: '0',
        notes: '',
        details: '',
        imbalance: 0,
        voucherID: 0,
        curBalType: 'Db',
        payMode: 0,
        payRef: "",
        isPayment: false,
        isPaymentShow: false,
        voucherFile: "",
        createdDate: this.pipe.transform(this.now, 'dd-MMM-yy'),
        EnteredByName: ''
    }
    type = [
        {
            id: 1,
            name: 'Bank Payment'
        },
        {
            id: 2,
            name: 'Bank Receipt'
        },
        {
            id: 3,
            name: 'Cash Payment'
        },
        {
            id: 4,
            name: 'Cash Receipt'
        },
        {
            id: 5,
            name: 'Journal Voucher'
        },
        {
            id: 6,
            name: 'Purchase Voucher'
        },
        {
            id: 7,
            name: 'Sale Voucher'
        },
        {
            id: 8,
            name: 'Contra Entry'
        },
        {
            id: 9,
            name: 'Salary'
        }
    ]

    printVoucherData() {
        setTimeout(function () {
            var printArea = $('#VoucherPrint').html();
            $('body').html(printArea);
            window.print();
        });
    }

    ngOnInit(): void {
        this.vuchrID = this.commonService.GetParam('VID');
        this.vuchrHistoryID = this.commonService.GetParam('VHID');

        let agencyData = this.apiService.getCookie("M");
        if (agencyData) {
            this.agencyData = JSON.parse(agencyData);
        }

        let userData = this.apiService.getCookie("J");
        if (userData) {
            this.userData = JSON.parse(userData);
        }

        var jarvis = this.apiService.getCookie("Jarvis");
        if (jarvis) {
            this.jarvisData = JSON.parse(jarvis);
        }

        var ledger = this.apiService.getCookie("Ledger");
        if(ledger){
            this.ledgers = JSON.parse(ledger);
        }

        if(this.vuchrHistoryID != 0 && this.vuchrID != 0){
            this.getVchrHistoryData();
        }
        else
        {
            this.getEditData();
        }
        
        
        //this.printVoucherData()
    }

    //getEditData()
    getEditData() {
        this.AgencyName = this.agencyData[0].AgencyName;
        this.City = this.agencyData[0].City;
        this.State = this.agencyData[0].State;
        //this.ledgerName = this.commonService.GetParam('Name')
        var tempData = [{
            'voucherID': this.commonService.GetParam('VID')
        }]
        let myParams = [{
            myUserID: this.jarvisData[0].UserID,
            myToken: this.jarvisData[0].WebToken,
            forAgencyID: this.jarvisData[0].AgencyIDs,
            myAgencyIDs: this.jarvisData[0].AgencyIDs,
            myLastSyncDT: null,
            isWeb: true,
            ForERPAgencyID: this.agencyData[0].ERPAgencyID,
            actionType: 'initEdit',
            moduleID: 0,
            data: JSON.stringify(tempData)
        }];
        this.apiService.getData(myParams, this.successEditResp.bind(this), this.failureResp.bind(this));

    }

    //successResp - success  get handler
    successEditResp(res: any) {
        if (res.error) {
        }
        else {
            if (res) {
                var reponseData = JSON.parse(res.updatePackage);
                if (reponseData.Table1[0]) {
                    if(this.vuchrID != 0) {
                    let editDataArry = reponseData.Table1;
                    //this.voucherHistoryData = reponseData.Table3;
                    this.editDataList = editDataArry;
                    this.dataTbl = [];
                    var creditsum = 0;
                    var debitSum = 0;
                    for (let i = 0; i < this.editDataList.length; i++) {
                        this.data.voucherNO = this.editDataList[i].VoucherNo;
                        this.data.voucherDate = new Date(this.editDataList[i].EffectiveDate).customFormat("#DD#-#MMM#-#YY#");
                        this.data.createdDate = new Date(this.editDataList[i].CreatedDT).customFormat("#DD#-#MMM#-#YY#");
                        this.data.details = this.editDataList[i].MainNotes;
                        this.data.voucherType = "";
                        this.data.voucherTypeID = this.editDataList[i].VoucherTypeID;
                        let tmpVchrId = this.data.voucherTypeID;
                        this.data.EnteredByName = this.editDataList[i].EnteredByName;
                        let tmpVoucherName = this.type.filter(function (element: any, index: any) {
                            return (element.id == tmpVchrId);
                        });
                        this.data.voucherType = tmpVoucherName[0].name;
                        var curBalType = "";
                        if (this.editDataList[0].CurrentBal < '0') {
                            this.editDataList[i].CurrentBal = 0 - (this.editDataList[0].CurrentBal);
                            curBalType = ' Cr';
                            

                        }
                        else {
                            this.editDataList[i].CurrentBal = this.editDataList[0].CurrentBal;
                            curBalType = ' Db'
                        }
                        this.dataTbl.push({
                            'ledgerID': this.editDataList[i].LedgerID,
                            'ledgerName': this.editDataList[i].Ledger,
                            'credit': this.editDataList[i].CreditAmount,
                            'debit': this.editDataList[i].DebitAmount,
                            'notes': this.editDataList[i].ItemNotes,
                            'curBal': this.editDataList[i].CurrentBal,
                            'curBalType': curBalType

                        })
                        creditsum = creditsum + this.editDataList[i].CreditAmount;
                        debitSum = debitSum + this.editDataList[i].DebitAmount;
                    }
                    this.CreditTotal = creditsum;
                    this.DebitTotal = debitSum;
                    this.printVoucherData();
                }
                else
                {
                    let vochrHistryData = reponseData.Table1;
                    console.log('historyData', vochrHistryData)
                }
              }
            }
        }
    }

    //failureResp - failure handler
    failureResp(res: any) {
        if (res.error) {
        }
        else {
            alert(res.message);
        }
    }

    //getEditData()
    getVchrHistoryData() {
        this.AgencyName = this.agencyData[0].AgencyName;
        this.City = this.agencyData[0].City;
        this.State = this.agencyData[0].State;
        //this.ledgerName = this.commonService.GetParam('Name')
        var tempData = [{
            'voucherID': this.vuchrID ? this.vuchrID : 0,
            'voucherHistoryID': this.vuchrHistoryID ? this.vuchrHistoryID : 0
        }]
        let myParams = [{
            myUserID: this.jarvisData[0].UserID,
            myToken: this.jarvisData[0].WebToken,
            forAgencyID: this.jarvisData[0].AgencyIDs,
            myAgencyIDs: this.jarvisData[0].AgencyIDs,
            myLastSyncDT: null,
            isWeb: true,
            ForERPAgencyID: this.agencyData[0].ERPAgencyID,
            actionType: 'vchrHistoryData',
            moduleID: 0,
            data: JSON.stringify(tempData)
        }];
        this.apiService.getData(myParams, this.successVhrHistoryResp.bind(this), this.failureVhrHistoryResp.bind(this));

    }

    //successResp - success  get handler
    successVhrHistoryResp(res: any) {
        if (res.error) {
        }
        else {
            if (res) {
                var reponseData = JSON.parse(res.updatePackage);
                if (reponseData.Table1[0]) {
                    let editDataArry = reponseData.Table1;
                    this.editDataList = editDataArry;
                    if(this.editDataList.length > 0){
                    var voucherHistoryData = JSON.parse(this.editDataList[0].VoucherData);
                    var voucherEntryData = JSON.parse(voucherHistoryData[0].VchrEntries);                   
                    this.dataTbl = [];
                    var creditsum = 0;
                    var debitSum = 0;
                    for (let i = 0; i < voucherHistoryData.length; i++) {
                        this.data.voucherNO = voucherHistoryData[i].VchrNo;
                        this.data.voucherDate = new Date(voucherHistoryData[i].VchrDT).customFormat("#DD#-#MMM#-#YY#");
                        this.data.createdDate = new Date(voucherHistoryData[i].EnteredOn).customFormat("#DD#-#MMM#-#YY#");
                        this.data.details = voucherHistoryData[i].CommonNotes;
                        this.data.voucherType = "";
                        this.data.voucherTypeID = voucherHistoryData[i].VchrType;
                        let tmpVchrId = this.data.voucherTypeID;
                        let enterUserID = voucherHistoryData[i].EnteredByUID;
                        let tmpUserName = this.userData.filter(function (element: any, index: any) {
                            return (element.UserID == enterUserID);
                        });
                        this.data.EnteredByName = tmpUserName[0].Name;
                        let tmpVoucherName = this.type.filter(function (element: any, index: any) {
                            return (element.id == tmpVchrId);
                        });
                        this.data.voucherType = tmpVoucherName[0].name;
                    }
                    
                    for (let j = 0; j < voucherEntryData.length; j++) {
                    var tempLedger:any = this.ledgers.filter(function (element: any) {
                        return (element.LedgerID == voucherEntryData[j].LedgerID);
                    });

                    this.dataTbl.push({
                        'ledgerID': tempLedger[0].LedgerID,
                        'ledgerName': tempLedger[0].LedgerName,
                        'credit': voucherEntryData[j].CrAmt,
                        'debit': voucherEntryData[j].DbAmt,
                        'notes': voucherEntryData[j].Notes
                    })
                    creditsum = creditsum + voucherEntryData[j].CrAmt;
                    debitSum = debitSum + voucherEntryData[j].DbAmt;

                    this.CreditTotal = creditsum;
                    this.DebitTotal = debitSum;
                }
                    this.printVoucherData();
                }
              }
            }
        }
    }

    //failureResp - failure handler
    failureVhrHistoryResp(res: any) {
        if (res.error) {
        }
        else {
            alert(res.message);
        }
    }

}


declare global {
    interface Date {
        customFormat(formatString: any): string;
    }
}

Date.prototype.customFormat = function (formatString: any) {
    var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhhh, hhh, hh, h, mm, m, ss, s, ampm, AMPM, dMod, th;
    YY = ((YYYY = this.getFullYear()) + "").slice(-2);
    MM = (M = this.getMonth() + 1) < 10 ? ('0' + M) : M;
    MMM = (MMMM = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][M - 1]).substring(0, 3);
    DD = (D = this.getDate()) < 10 ? ('0' + D) : D;
    DDD = (DDDD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][this.getDay()]).substring(0, 3);
    th = (D >= 10 && D <= 20) ? 'th' : ((dMod = D % 10) == 1) ? 'st' : (dMod == 2) ? 'nd' : (dMod == 3) ? 'rd' : 'th';
    formatString = formatString.replace("#YYYY#", YYYY).replace("#YY#", YY).replace("#MMMM#", MMMM).replace("#MMM#", MMM).replace("#MM#", MM).replace("#M#", M).replace("#DDDD#", DDDD).replace("#DDD#", DDD).replace("#DD#", DD).replace("#D#", D).replace("#th#", th);
    h = (hhh = this.getHours());
    if (h == 0) h = 24;
    if (h > 12) h -= 12;
    hh = h < 10 ? ('0' + h) : h;
    hhhh = h < 10 ? ('0' + hhh) : hhh;
    AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
    mm = (m = this.getMinutes()) < 10 ? ('0' + m) : m;
    ss = (s = this.getSeconds()) < 10 ? ('0' + s) : s;
    return formatString.replace("#hhhh#", hhhh).replace("#hhh#", hhh).replace("#hh#", hh).replace("#h#", h).replace("#mm#", mm).replace("#m#", m).replace("#ss#", ss).replace("#s#", s).replace("#ampm#", ampm).replace("#AMPM#", AMPM);
}
